import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import WhatsappAccountsAPI from '../../api/whatsappAccounts';
import { throwErrorMessage } from 'dashboard/store/utils/api';
import {updateAttributes} from "../../../shared/helpers/vuex/mutationHelpers";

const state = {
  records: [],
  meta: {
    count: 0,
    currentPage: 1,
  },
  uiFlags: {
    fetchingList: false,
    fetchingItem: false,
    creatingItem: false,
    updatingItem: false,
    deletingItem: false,
    getQRCode: false,
  },
  base64QRCode: '',
};

const getters = {
  getWhatsappAccounts(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getMeta(_state) {
    return _state.meta;
  },
  getBase64QRCode(_state) {
    return _state.base64QRCode;
  },
  getFilteredWhatsappAccounts: (_state) => (inbox_name) => {
    const filteredAccounts = _state.records.filter(account => account.inbox_name === inbox_name);
    return {
      accounts: filteredAccounts,
      count: filteredAccounts.length,
    };
  },
};

const actions = {
  async fetch({ commit }, { page, channel_id } = {}) {
    commit(types.default.SET_WHATSAPP_ACCOUNTS_UI_FLAG, { fetchingList: true });
    try {
      const {
        data: { payload, meta },
      } = await WhatsappAccountsAPI.get({ page, channel_id });

      commit(types.default.SET_WHATSAPP_ACCOUNTS, payload);
      commit(types.default.SET_WHATSAPP_ACCOUNTS_META, meta);
      commit(types.default.SET_WHATSAPP_ACCOUNTS_UI_FLAG, {
        fetchingList: false,
      });
      return payload;
    } catch (error) {
      commit(types.default.SET_WHATSAPP_ACCOUNTS_UI_FLAG, {
        fetchingList: false,
      });
      return throwErrorMessage(error);
    }
  },

  async all({ commit }) {
    try {
      const response = await WhatsappAccountsAPI.all();
      commit(types.default.SET_WHATSAPP_ACCOUNTS, response.data);
      return response.data;
    } catch (error) {
      return throwErrorMessage(error);
    }
  },

  createWhatsappAccount: async function createWhatsappAccount(
    { commit },
    whatsappAccountObj
  ) {
    commit(types.default.SET_WHATSAPP_ACCOUNTS_UI_FLAG, { creatingItem: true });
    try {
      const response = await WhatsappAccountsAPI.create(whatsappAccountObj);
      commit(types.default.ADD_WHATSAPP_ACCOUNT, response.data);
      commit(types.default.SET_WHATSAPP_ACCOUNTS_UI_FLAG, {
        creatingItem: false,
      });
      return response.data;
    } catch (error) {
      commit(types.default.SET_WHATSAPP_ACCOUNTS_UI_FLAG, {
        creatingItem: false,
      });
      return throwErrorMessage(error);
    }
  },

  updateWhatsappAccount: async function updateWhatsappAccount(
    { commit },
    { id, ...updateObj }
  ) {
    commit(types.default.SET_WHATSAPP_ACCOUNTS_UI_FLAG, { updatingItem: true });
    try {
      const response = await WhatsappAccountsAPI.update(id, updateObj);
      commit(types.default.EDIT_WHATSAPP_ACCOUNT, response.data);
      commit(types.default.SET_WHATSAPP_ACCOUNTS_UI_FLAG, {
        updatingItem: false,
      });
      return response.data;
    } catch (error) {
      commit(types.default.SET_WHATSAPP_ACCOUNTS_UI_FLAG, {
        updatingItem: false,
      });
      return throwErrorMessage(error);
    }
  },

  deleteWhatsappAccount: async function deleteWhatsappAccount({ commit }, id) {
    commit(types.default.SET_WHATSAPP_ACCOUNTS_UI_FLAG, { deletingItem: true });
    try {
      await WhatsappAccountsAPI.delete(id);
      commit(types.default.DELETE_WHATSAPP_ACCOUNT, id);
      commit(types.default.SET_WHATSAPP_ACCOUNTS_UI_FLAG, {
        deletingItem: true,
      });
      return id;
    } catch (error) {
      commit(types.default.SET_WHATSAPP_ACCOUNTS_UI_FLAG, {
        deletingItem: true,
      });
      return throwErrorMessage(error);
    }
  },

  getWhatsappAccountQRCode: async function getWhatsappAccountQRCode(
    { commit },
    id
  ) {
    try {
      const {
        data: { qrcode },
      } = await WhatsappAccountsAPI.session_qr(id);
      commit(types.default.SET_WHATSAPP_ACCOUNT_QR_CODE, qrcode);
      commit(types.default.SET_WHATSAPP_ACCOUNTS_UI_FLAG, {
        getQRCode: true,
      });
      return qrcode;
    } catch (error) {
      commit(types.default.SET_WHATSAPP_ACCOUNTS_UI_FLAG, {
        getQRCode: true,
      });
      return throwErrorMessage(error);
    }
  },

  getWhatsappAccountStatus: async function getWhatsappAccountQRCode(
    // eslint-disable-next-line no-unused-vars
    { commit },
    id
  ) {
    try {
      const {
        data: { logged_in },
      } = await WhatsappAccountsAPI.session_status(id);
      commit(types.default.UPDATE_WHATSAPP_ACCOUNT, {
        id: id,
        online: 'online',
      });
      return logged_in;
    } catch (error) {
      return throwErrorMessage(error);
    }
  },
  logoutWhatsappAccount: async function logoutWhatsappAccount(
    // eslint-disable-next-line no-unused-vars
    { commit },
    id
  ) {
    try {
      await WhatsappAccountsAPI.session_logout(id);
      commit(types.default.UPDATE_WHATSAPP_ACCOUNT, {
        id: id,
        online: '',
      });
      return true;
    } catch (error) {
      return throwErrorMessage(error);
    }
  },
};

const mutations = {
  [types.default.SET_WHATSAPP_ACCOUNTS_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.default.SET_WHATSAPP_ACCOUNTS]: MutationHelpers.set,
  [types.default.SET_WHATSAPP_ACCOUNTS_META](_state, data) {
    _state.meta = {
      ..._state.meta,
      ...data,
    };
  },
  [types.default.ADD_WHATSAPP_ACCOUNT]: MutationHelpers.create,
  [types.default.EDIT_WHATSAPP_ACCOUNT]: MutationHelpers.update,
  [types.default.UPDATE_WHATSAPP_ACCOUNT]: MutationHelpers.updateAttributes,
  [types.default.DELETE_WHATSAPP_ACCOUNT]: MutationHelpers.destroy,
  [types.default.SET_WHATSAPP_ACCOUNT_QR_CODE](_state, data) {
    _state.base64QRCode = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
